import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'app/core/guards/auth.guard';
import { AdminLayoutComponent } from 'app/layouts/admin/admin-layout.component';
import { CuentasXCobrarComponent } from './pages/cuentas-x-cobrar/cuentas-x-cobrar.component';


const routes: Routes = [
  {
    path: "",
    component: AdminLayoutComponent,
    data: {
      breadcrumb: "Cuentas por cobrar",
    },
    children: [
      {
        path: "cuentas-x-cobrar",
        canActivate: [AuthGuard],
        component: CuentasXCobrarComponent,
        data: {
          breadcrumb: "Cuentas por cobrar",
        },
      },
      {
        path: 'cuentas-x-cobrar/:aceptante',
        component: CuentasXCobrarComponent,
        data: {
          breadcrumb: 'Documentos Cartera'
        }
      }      
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CuentasXCobrarRoutingModule { }
